<template>
  <section>
    <div class="pb-4">
      <FullFit v-if="matchStatus === 'FULL FIT'" />
      <NoFit v-else-if="matchStatus === 'NO FIT'" />
      <Raw v-else />
      <b-row class="mt-3">
        <b-col md="12" class="text-left">
          <b-button
            v-if="friendsVerification || groupsVerification"
            variant="link"
            @click="$router.push({ name: 'others' })"
            class="font-weight-bold"
            ><Frends class="mr-1" /><u>{{
              $t("product-match-someone-else")
            }}</u>
          </b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="12" class="text-left">
          <b-button
            variant="link"
            @click="$store.dispatch('application/close')"
            class="font-weight-bold"
          >
            <CartBlack class="mr-1" />
            <u> {{ $t("product-match-continue-shopping") }}</u>
          </b-button>
        </b-col>
      </b-row>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import FullFit from "../../components/match/full-fit";
import NoFit from "../../components/match/no-fit";
import Raw from "../../components/match/raw";
import Frends from "../../assets/images/frends.svg";
import CartBlack from "../../assets/images/cart-black.svg";

export default {
  name: "pages-product-match",
  components: {
    Frends,
    CartBlack,
    FullFit,
    NoFit,
    Raw
  },
  created() {
    this.$store.commit(
      "ui/SET_LOADING_TEXT",
      this.$t("match-loading-checking")
    );
    this.$store.commit("ui/SET_LOADING", true);
    this.$store
      .dispatch("users/matchUser")
      .then(() => this.$store.commit("ui/SET_LOADING", false))
      .catch(() => this.$store.commit("ui/SET_LOADING", false));
  },
  computed: {
    ...mapGetters({
      last_updated_at: "users/getSelfLastUpdated",
      matchSize: "users/getSelfMatchSize",
      productCombinations: "pageParams/getProductCombinations",
      name: "users/getSelfFirstName",
      matchResult: "users/getSelfMatchStatus",
      contacts: "contacts/getContacts",
      groups: "groups/getGroups"
    }),
    matchStatus() {
      if (
        this.matchResult === "FULL FIT" &&
        !this.productCombinations.find(
          c => c.size.toLowerCase() === this.matchSize.toLowerCase()
        )
      ) {
        return "NO FIT";
      }
      return this.matchResult;
    },
    groupsVerification() {
      return (
        this.groups.some(group => group["has_members"] === true) &&
        this.groups.some(group => group["state"] === "owner")
      );
    },
    friendsVerification() {
      return this.contacts.some(friend => friend["active_bodyprint"] != null);
    }
  },
  methods: {
    logout() {
      this.$store
        .dispatch("auth/logout", this.form)
        .then(() => this.$router.push({ name: "login" }));
    }
  }
};
</script>
